<template>
    <v-layout row wrap>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.email"
                label="E-Mail"
                :rules="rules.email"
                name="email"
            >
            </s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.repeatEmail"
                label="E-Mail wiederholen"
                :rules="rules.repeatEmail"
            ></s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-select
                v-model="attendee.salutation"
                label="Anrede"
                :items="['Herr', 'Frau']"
                :rules="rules.salutation"
                name="salutation"
                browser-autocomplete="false"
            >
            </s-select>
        </v-flex>
        <v-flex xs12 md6>
            <s-select
                v-model="attendee.title"
                label="Titel (optional)"
                :items="['Dr.', 'Prof.', 'Prof. Dr.', 'PD', 'PD Dr.']"
                clearable
                name="title"
                browser-autocomplete="false"
            >
            </s-select>
        </v-flex>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.first_name"
                label="Vorname"
                :rules="rules.first_name"
                name="fname"
            >
            </s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.last_name"
                label="Nachname"
                :rules="rules.last_name"
                name="lname"
            ></s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.street"
                label="Straße, Hausnummer"
                :rules="rules.street"
                name="street"
            >
            </s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.street_suffix"
                label="Adresszusatz (optional)"
                :rules="rules.street_suffix"
                name="street_suffix"
            ></s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.postcode"
                label="PLZ"
                :rules="rules.postcode"
                name="plz"
            >
            </s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-text-field
                v-model="attendee.city"
                label="Ort"
                :rules="rules.city"
                name="city"
            ></s-text-field>
        </v-flex>
        <v-flex xs12 md6>
            <s-select
                v-model="attendee.country_code"
                label="Land"
                :rules="rules.country_code"
                :items="countries"
                @change="attendee.state_code=null"
                name="country"
                browser-autocomplete="false"
            >
            </s-select>
        </v-flex>
        <v-flex xs12 md6>
            <s-select
                v-model="attendee.state_code"
                label="Bundesland"
                :rules="rules.state_code"
                :items="selectableStates"
                name="state"
                browser-autocomplete="false"
            >
            </s-select>
        </v-flex>
        <v-flex xs12 v-for="(formField, idx) in event.form_fields" :key="idx">
            <v-text-field
                v-if="formField.type === 'GenericText'"
                v-model="attendee.formResultFields[formField.id].value"
                :rules="rules[`formFields.${formField.id}`]"
                :label="formField.label">
            </v-text-field>
            <v-select
                v-else-if="formField.type === 'GenericSelect'"
                v-model="attendee.formResultFields[formField.id].value"
                :rules="rules[`formFields.${formField.id}`]"
                :multiple="!!formField.multi"
                :items="formField.items"
                :label="formField.label">
            </v-select>
            <v-select
                v-else-if="formField.type === 'Fachgebiet'"
                v-model="attendee.formResultFields[formField.id].value"
                :rules="rules[`formFields.${formField.id}`]"
                :multiple="!!formField.multi"
                :items="formField.items"
                :label="formField.label">
            </v-select>
            <v-checkbox
                v-if="formField.type === 'GenericCheckbox'"
                v-model="attendee.formResultFields[formField.id].value"
                :rules="rules[`formFields.${formField.id}`]"
                :label="formField.label">
            </v-checkbox>
            <v-text-field
                v-if="formField.type === 'Mobile'"
                v-model="attendee.formResultFields[formField.id].value"
                :rules="rules[`formFields.${formField.id}`]"
                label="Mobilnummer"/>
            <v-text-field
                v-if="formField.type === 'EFN'"
                v-model="attendee.formResultFields[formField.id].value"
                :rules="rules[`formFields.${formField.id}`]"
                :label="formField.label">
            </v-text-field>
        </v-flex>
        <v-flex xs12 v-if="ticket.ticket_type.student_pj">
            <v-checkbox
                v-model="attendee.student_pj"
                :rules="rules.student_pj"
                label="Student der Medizin im praktischen Jahr. (Bitte halten Sie Ihren Studienausweis bei der Veranstaltung bereit.)">
            </v-checkbox>
        </v-flex>
        <v-flex xs12 v-if="ticket.ticket_type.student">
            <v-checkbox
                v-model="attendee.student"
                :rules="rules.student"
                label="Student der Medizin. (Bitte halten Sie Ihren Studienausweis bei der Veranstaltung bereit.)">
            </v-checkbox>
        </v-flex>
        <v-flex xs12 v-if="ticket.ticket_type.member">
            <v-checkbox
                v-model="attendee.member"
                :rules="rules.member"
                label="Mitglied im Marburger Bund">
            </v-checkbox>
        </v-flex>
        <template v-if="ticket.ticket_type.partner">
            <v-flex xs12>
                <v-checkbox
                    v-model="selectedPartner"
                    :rules="rules.partner"
                    value="member"
                    label="Ich bin Mitglied im Marburger Bund">
                </v-checkbox>
            </v-flex>
            <v-flex xs12>
                <v-checkbox
                    v-model="selectedPartner"
                    :rules="rules.partner"
                    value="partner_amboss"
                    label="Ich bin Amboss Abonnent">
                </v-checkbox>
            </v-flex>
            <v-flex xs12>
                <v-checkbox
                    v-model="selectedPartner"
                    :rules="rules.partner"
                    value="partner_amboss_campus"
                    label="Ich besitze eine Amboss Campuslizenz">
                </v-checkbox>
            </v-flex>
        </template>
    </v-layout>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "AttendeeForm",
    props: {
        attendee: Object,
        ticket: Object,
        countries: Array,
        states: Object,
    },
    computed: {
        ...mapState('form', [
            'event',
        ]),
        selectableStates() {
            if (!this.attendee) {
                return [];
            } else if (this.attendee.country_code === 'DE') {
                return this.states.germanStates;
            } else if (this.attendee.country_code === 'AT') {
                return this.states.austrianStates;
            } else if (this.attendee.country_code === 'CH') {
                return this.states.swissStates;
            } else {
                return []
            }
        },
        selectedPartner: {
            get() {
                return this.partners;
            },
            set(arr) {
                this.partners = arr.slice();
                this.attendee.member = arr.indexOf('member') !== -1;
                this.attendee.partner_amboss = arr.indexOf('partner_amboss') !== -1;
                this.attendee.partner_amboss_campus = arr.indexOf('partner_amboss_campus') !== -1;
            }
        },
        rules() {
            let fields = {
                email: ['required', 'email', 'maxLen:255'],
                repeatEmail: ['required', (v) => (v === this.attendee.email || 'E-mail Adressen stimmen nicht überein.')],
                salutation: ['required'],
                first_name: ['required', 'maxLen:255'],
                last_name: ['required', 'maxLen:255'],
                street: ['required', 'maxLen:255'],
                street_suffix: ['maxLen:255'],
                postcode: ['required', 'maxLen:255'],
                city: ['required', 'maxLen:255'],
                country_code: ['required'],
                state_code: [],
                student: ['required'],
                student_pj: ['required'],
                member: ['required'],
                partner: [() => (this.selectedPartner.length > 0 || 'Bitte wählen Sie mindestens eine Option.')],
            }
            this._.forEach(this.event.form_fields, (formField) => {
                let rules = []
                if (formField.mandatory) {
                    if (formField.multi) {
                        rules.push('requireMultiple:1')
                    } else {
                        rules.push('required')
                    }
                }
                if (formField.type === 'EFN') {
                    rules.push('efn')
                }
                fields[`formFields.${formField.id}`] = rules
            })
            return this.$validation.create(fields)
        }
    },
    data() {
        return {
            partners: [],
        }
    },
}
</script>

<style scoped>

</style>
